import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';
import Steps from 'hb-react/shared/components/DesignSystem/Steps';
import RequiredExplanation from 'hb-react/shared/components/formik/components/RequiredExplanation';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const Layout = ({ children, sidebar, navigation = [], orderSummaryOnTop }) => {
  const { flagEvOrderSummaryDsMemberships } = useFeatureFlag();
  const breakpoint = useBreakpoint();

  const { requiredExplanation } = navigation.find(({ active }) => active) || {};

  return (
    <Container height="auto">
      <Box display="block" width="100%" mt={4} pb={8}>
        <Grid rowGap={0} mb={flagEvOrderSummaryDsMemberships ? '72px' : '92px'}>
          <Row>
            <LeftColumn>
              <Header navigation={navigation} />
            </LeftColumn>
          </Row>
          <Row>
            <LeftColumn>
              {requiredExplanation && ['s', 'm'].includes(breakpoint) && (
                <Box mb={4}>
                  <RequiredExplanation mt={0} mb={0} />
                </Box>
              )}
              <Box display="block" position="relative">
                {children}
              </Box>
            </LeftColumn>
            <Col
              width={({ numCols }) => ({
                _: 1,
                l: flagEvOrderSummaryDsMemberships ? 5 / numCols : 4 / numCols,
                xl: flagEvOrderSummaryDsMemberships ? 4 / numCols : 3 / numCols,
              })}
              offset={({ numCols }) => ({
                _: 0,
                l: flagEvOrderSummaryDsMemberships ? 0 : 1 / numCols,
              })}
              order={{
                _:
                  orderSummaryOnTop || !flagEvOrderSummaryDsMemberships ? 1 : 2,
                l: 2,
              }}
              mb={orderSummaryOnTop ? 4 : 0}
            >
              {sidebar}
            </Col>
          </Row>
        </Grid>
      </Box>
    </Container>
  );
};

const Header = ({ navigation }) => {
  const outboxedFontTheme = useOutboxedFontTheme();
  const breakpoint = useBreakpoint();

  const { requiredExplanation } = navigation.find(({ active }) => active) || {};

  return (
    <ThemeProvider
      theme={outboxedFontTheme.themeName}
      fontBrightness={outboxedFontTheme.fontBrightness}
    >
      <Box mb={4} id="steps">
        <Steps navigation={navigation} />
      </Box>
      {requiredExplanation && ['l', 'xl'].includes(breakpoint) && (
        <Box mb={4}>
          <RequiredExplanation mt={0} mb={0} />
        </Box>
      )}
    </ThemeProvider>
  );
};

export default Layout;

const LeftColumn = styled(Col).attrs({
  width: ({ numCols }) => ({
    _: 1,
    l: 7 / numCols,
    xl: 6 / numCols,
  }),
  offset: ({ numCols }) => ({
    _: 0,
    xl: 1 / numCols,
  }),
  order: { _: 2, l: 1 },
})``;
